export class Chatbot {
  constructor () {
    this.$chatbotAllowedHosts = [
      'bkkgs.ddev.site',
      'bkkgs.me-preview.de',
      'www.bkkgs.de'
    ]

    this.classes = {
      buttonOpen: 'botario-chat-floating-button-open',
      widgetOpen: 'botario-chat-widget-float-open'
    }
  }

  init () {
    if ($('body').hasClass('is--chatbot-epa')) {
      this.chatbot = {
        main: 'https://digitus-gilsei-epa-cc.apps.cloud.itsc.de/botario.js',
        config: 'https://digitus-gilsei-epa-cc.apps.cloud.itsc.de/botario.embed.6033773989b1d2003bc46da4.js'
      }

      if (((window.name === 'newTYPO3frontendWindow') || (typeof Cookiebot !== 'undefined' && Cookiebot.consent && Cookiebot.consent.preferences)) && this.$chatbotAllowedHosts.includes(window.location.host)) {
        this.loadChatbot()
      }
    }
  }

  addEvents () {
    const that = this

    that.checkTriggerPosition()
    $(document)
      .scroll(function () {
        that.checkTriggerPosition()
      })

    that.$elements.chatbotLink.click(function (event) {
      that.chatbotLinkClickHandler(event)
    })
  }

  checkTriggerPosition () {
    const that = this
    const scrollTillEnd = (($(document).height() - $(window).innerHeight()) - $(document).scrollTop())

    if (scrollTillEnd < 150) {
      that.$elements.chatbotContainer.hide()
    } else {
      that.$elements.chatbotContainer.show()
    }
  }

  chatbotLinkClickHandler (event) {
    const that = this

    event.preventDefault()

    that.$elements.chatbotTrigger = $('.botario-chat-floating #botario-button-wrapper button')
    if (that.$elements.chatbotTrigger.length >= 1) {
      that.$elements.chatbotTrigger.click()
    }
  }

  loadChatbot () {
    const that = this
    const chatbot = document.createElement('script')
    const chatBotId = 'chatbot'

    chatbot.id = chatBotId

    if ($('#' + chatBotId).length === 0) {
      $('body').append(chatbot)

      chatbot.addEventListener('load', () => {
        const config = document.createElement('script')
        $('body').append(config)

        config.addEventListener('load', () => {
          that.$elements = {
            chatbotContainer: $('#botario-button-wrapper'),
            chatbotLink: $('.chatbot-link'),
            chatbotTrigger: $('.botario-chat-floating #botario-button-wrapper button')
          }

          that.addEvents()
        })

        config.src = that.chatbot.config
      })

      chatbot.src = that.chatbot.main
    }
  }
}

export default Chatbot
